/**
 * @file video-track-list.js
 */
'use strict';

exports.__esModule = true;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _trackList = require('./track-list');

var _trackList2 = _interopRequireDefault(_trackList);

var _utilsBrowserJs = require('../utils/browser.js');

var browser = _interopRequireWildcard(_utilsBrowserJs);

var _globalDocument = require('global/document');

var _globalDocument2 = _interopRequireDefault(_globalDocument);

/**
 * disable other video tracks before selecting the new one
 *
 * @param {Array|VideoTrackList} list list to work on
 * @param {VideoTrack} track the track to skip
 */
var disableOthers = function disableOthers(list, track) {
  for (var i = 0; i < list.length; i++) {
    if (track.id === list[i].id) {
      continue;
    }
    // another audio track is enabled, disable it
    list[i].selected = false;
  }
};

/**
* A list of possiblee video tracks. Most functionality is in the
 * base class Tracklist and the spec for VideoTrackList is located at:
 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist
 *
 * interface VideoTrackList : EventTarget {
 *   readonly attribute unsigned long length;
 *   getter VideoTrack (unsigned long index);
 *   VideoTrack? getTrackById(DOMString id);
 *   readonly attribute long selectedIndex;
 *
 *   attribute EventHandler onchange;
 *   attribute EventHandler onaddtrack;
 *   attribute EventHandler onremovetrack;
 * };
 *
 * @param {VideoTrack[]} tracks a list of video tracks to instantiate the list with
 # @extends TrackList
 * @class VideoTrackList
 */

var VideoTrackList = (function (_TrackList) {
  _inherits(VideoTrackList, _TrackList);

  function VideoTrackList() {
    var tracks = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];

    _classCallCheck(this, VideoTrackList);

    var list = undefined;

    // make sure only 1 track is enabled
    // sorted from last index to first index
    for (var i = tracks.length - 1; i >= 0; i--) {
      if (tracks[i].selected) {
        disableOthers(tracks, tracks[i]);
        break;
      }
    }

    // IE8 forces us to implement inheritance ourselves
    // as it does not support Object.defineProperty properly
    if (browser.IS_IE8) {
      list = _globalDocument2['default'].createElement('custom');
      for (var prop in _trackList2['default'].prototype) {
        if (prop !== 'constructor') {
          list[prop] = _trackList2['default'].prototype[prop];
        }
      }
      for (var prop in VideoTrackList.prototype) {
        if (prop !== 'constructor') {
          list[prop] = VideoTrackList.prototype[prop];
        }
      }
    }

    list = _TrackList.call(this, tracks, list);
    list.changing_ = false;

    Object.defineProperty(list, 'selectedIndex', {
      get: function get() {
        for (var i = 0; i < this.length; i++) {
          if (this[i].selected) {
            return i;
          }
        }
        return -1;
      },
      set: function set() {}
    });

    return list;
  }

  VideoTrackList.prototype.addTrack_ = function addTrack_(track) {
    var _this = this;

    if (track.selected) {
      disableOthers(this, track);
    }

    _TrackList.prototype.addTrack_.call(this, track);
    // native tracks don't have this
    if (!track.addEventListener) {
      return;
    }
    track.addEventListener('selectedchange', function () {
      if (_this.changing_) {
        return;
      }
      _this.changing_ = true;
      disableOthers(_this, track);
      _this.changing_ = false;
      _this.trigger('change');
    });
  };

  VideoTrackList.prototype.addTrack = function addTrack(track) {
    this.addTrack_(track);
  };

  VideoTrackList.prototype.removeTrack = function removeTrack(track) {
    _TrackList.prototype.removeTrack_.call(this, track);
  };

  return VideoTrackList;
})(_trackList2['default']);

exports['default'] = VideoTrackList;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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